import { useState, useEffect } from "react";
import moment from "moment";
import { Link, useLocation } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Avatar from "@mui/material/Avatar";
import MuiLink from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";

import WorkspacesIcon from "@mui/icons-material/Workspaces";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExitToAppIcon from '@mui/icons-material/ExitToApp';

const DatosGrupo = ({ grupo }) => {
  const location = useLocation();

  return (
    <Paper sx={{ mt: 1, mb: 2, p: { xs: 1, md: 2 } }}>
      <Grid container spacing={2}>
        <Grid item sx={{ display: "flex", flexDirection: "none" }}>
          <Avatar sx={{ backgroundColor: "#799F4F", mr: 2 }}>
            <WorkspacesIcon />
          </Avatar>
          <Box>
            <Typography variant="cuerpo" component="p">
              {grupo.nombre}
            </Typography>
            <Typography variant="aclaracion" component="p">
              {"Grupo"}
            </Typography>
          </Box>
        </Grid>
        {grupo.padre && (
          <Grid item>
            <Box sx={{ mx: 2 }}>
              <Typography variant="cuerpo" component="p">
                {/* {grupo.padre + " "} */}
                {/* <IconButton
                  title="Ver el padre"
                  size="small"
                  component={Link}
                  to={{
                    pathname: `/grupo/${grupo.padreId}`,
                    state: { from: location },
                  }}
                >
                  <ExitToAppIcon fontSize="small" />
                </IconButton> */}
                <MuiLink
                  component={Link}
                  to={`/grupo/${grupo.padreId}`}
                  // to={{
                  //   pathname: `/grupo/${grupo.padreId}`,
                  //   state: { from: location },
                  // }}
                  variant="body2"
                  sx={{ color: "#799F4F" }}
                  title={"Ver el padre"}
                >
                  {grupo.padre}
                </MuiLink>
              </Typography>
              <Typography variant="aclaracion" component="p">
                {"Grupo padre"}
              </Typography>
            </Box>
          </Grid>
        )}
        <Grid item>
          <Box sx={{ mx: 2 }}>
            <Typography variant="cuerpo" component="p">
              {grupo.visibilidad}
            </Typography>
            <Typography variant="aclaracion" component="p">
              {"Visibilidad"}
            </Typography>
          </Box>
        </Grid>
        <Grid item>
          <Box sx={{ mx: 2 }}>
            <Typography variant="cuerpo" component="p">
              {grupo.accesoSistema === "S" ? "Si" : "No"}
            </Typography>
            <Typography variant="aclaracion" component="p">
              {"Tiene acceso al sistema"}
            </Typography>
          </Box>
        </Grid>
        <Grid item>
          <Box sx={{ mx: 2 }}>
            <Typography variant="cuerpo" component="p">
              {grupo.activo === "S" ? "Si" : "No"}
            </Typography>
            <Typography variant="aclaracion" component="p">
              {"Activo"}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default DatosGrupo;
